import React, { useEffect, useState } from 'react';
import requestManager from '../utils/requestManager.js';
import Login from '../screens/Login';

const Authentication = (props) => {

    const {user, setUser} = props;

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('silicom_token');
        if (token !== null) {
            
            requestManager('/ADKomodoUserLimited', 'GET', null,
                (res) => {
                    if (res) {
                        setUser(res);
                        setLoading(false);
                    }
                    else {
                        localStorage.removeItem('silicom_token');
                    }
                }
            );
        }
        else {
            setLoading(false);
        }
    }, []);

    if (loading) {
        return <div className="uk-container">
            <div className="mc-widget uk-text-center">
                <div data-uk-spinner="ratio: 2" style={{margin:"20px"}}></div>
            </div>
        </div>;
    }
    else if (user) {
        return props.children;
    }
    else {
        return <Login />;
    }
}

export default Authentication;